import { useForm } from '@conform-to/react'
import { parseWithZod } from '@conform-to/zod'
import { useFetcher } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import { useHydrated } from 'remix-utils/use-hydrated'
import {
	RESEND_VERIFICATION_EMAIL_FORM,
	resendVerificationEmailSchema,
} from '#app/components/forms/resend-verification-email-form/resend-verification-email-form.tsx'
import { PROFILE_INDEX_I18NEXT } from '#app/routes/($lang).profile._index/route-config'
import { ROOT_INPUTS } from '#app/routes/_layout/route-config.ts'

function useResendVerificationEmailForm() {
	const { t } = useTranslation(PROFILE_INDEX_I18NEXT.routeProfileIndex)
	const isHydrated = useHydrated()

	const resendVerificationEmailFetcherKey =
		RESEND_VERIFICATION_EMAIL_FORM.subaction
	const resendVerificationEmailFetcher = useFetcher({
		key: resendVerificationEmailFetcherKey,
	})

	const resendVerificationEmailFormValues = {
		[ROOT_INPUTS.subaction]: RESEND_VERIFICATION_EMAIL_FORM.subaction,
		[ROOT_INPUTS.noJs]: String(!isHydrated),
	}
	const [resendVerificationEmailForm, resendVerificationEmailFields] = useForm({
		onValidate({ formData }) {
			return parseWithZod(formData, {
				schema: resendVerificationEmailSchema,
			})
		},
		shouldValidate: 'onSubmit',
	})

	return {
		resendVerificationEmailFetcherKey,
		resendVerificationEmailFetcher,
		resendVerificationEmailFormValues,
		resendVerificationEmailForm,
		resendVerificationEmailFields,
		t,
	}
}

export { useResendVerificationEmailForm }
